import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { IPaginatedResponse, IResponse } from "../interfaces/response";

type TQuery = {
  auditTrailId: string;
};

type TAuditTrail = {
  actionDate: string;
  status: string | null;
  comment: string;
  action: string;
  startedBy: string | null;
  completedBy: string;
  entityName: string;
  initiatedByDetails: {
    userId: number;
    lastName: string;
    firstName: string;
    email: string;
    phoneNumber: string;
  };
  customerDetails: {
    customerId: number;
    lastName: string;
    firstName: string;
    email: string;
    phoneNumber: string;
  };
};

const getAuditTrailDetails = async ({ auditTrailId }: TQuery) => {
  const { data } = await getData(
    `${ajaxEndpoints.PRODUCT_AUDITS_BY_ID}?auditTrailId=${auditTrailId}`
  );
  return data;
};

export default function useAuditTrailDetails({ auditTrailId }: TQuery) {
  return useQuery<IResponse<TAuditTrail>>(
    [{ auditTrailId }, "getAuditTrailDetails"],
    getAuditTrailDetails,
    {
      enabled: !!auditTrailId,
    }
  );
}
